<template lang="pug">
    #edit-account-dialog
        v-dialog(v-model="value" scrollable persistent max-width=640 eager)
            v-card 
                v-card-title 
                    .title {{editType==1? $t('ChartOfAccounts.__AddAccount'): $t('ChartOfAccounts.__EditAccount')}}
                v-card-text
                    v-form(v-model="formValid" ref="accountingForm")
                        .field-label 
                            span {{$t('ChartOfAccounts.__AccountType')}}
                            span.required *
                        AccountCategorySelector(v-model="editedItem.category")
                        //- v-select(v-model="editedItem.category" solo dense outlined :items="nowGroup" item-text="name" item-value="key" placeholder="選擇類別" :rules="[rules.required]")
                        .field-label 
                            span {{$t('ChartOfAccounts.__AccountName')}}
                            span.required *
                        v-text-field(v-model="editedItem.name" solo dense outlined required :rules="[rules.required]")
                        .field-label 
                            span {{$t('ChartOfAccounts.__AccountDescription')}}
                        v-textarea(v-model="editedItem.description" solo outlined height="80")
                        v-divider
                        .archive-checkbox(v-if="editType!=1")
                            v-checkbox(v-model="editedItem.isArchived" :label="$t('ChartOfAccounts.__ArchiveAccount')" :messages="$t('ChartOfAccounts.__ArchiveAccountNote')")
                            v-divider.mt-4

                v-card-actions.justify-center.mb-6
                    v-btn.mr-6(rounded dark @click="cancelEditDialog" color="lightGray" width='112') {{$t('ActionOption.__Cancel')}}
                    v-btn(rounded dark @click="saveEdit" color="primary" width='112') {{$t('ActionOption.__Save')}}
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    accountCategoryGroups: {
      type: Array,
      default: () => {
        return []
      }
    },
    editType: {
      type: Number,
      default: 1
    },
    editedItem: {
      type: Object,
      default: function() {
        return {}
      }
    },
    confirmAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      formValid: false,
      rules: textfieldUtils.rules
    }
  },
  methods: {
    saveEdit() {
      this.$refs.accountingForm.validate()
      if (this.formValid) {
        if (this.editType == 1) {
          this.createAccount()
        } else {
          this.updateAccount()
        }
      }
    },
    createAccount() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("accounting/createAccount", this.editedItem)
        .then(
          function(response) {
            this.confirmAction(response.data.accountId)
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    updateAccount() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("accounting/updateAccount", this.editedItem)
        .then(
          function(response) {
            this.confirmAction()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyUpdated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    cancelEditDialog() {
      this.$emit("input", false)
      this.$refs.accountingForm.resetValidation()
      this.$refs.accountingForm.reset()
    }
  }
}
</script>
